import { useState } from "react";
import { supabase } from "../supabase";
import { styles } from "../styles/appStyles";

export default function ResetPasswordPage() {
  const [password, setPassword] = useState("");
  const [confirmPw, setConfirmPw] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const handleReset = async (e) => {
    e.preventDefault();
    if (password !== confirmPw) { setError("Passwords do not match."); return; }
    setLoading(true); setError(null);
    const { error: err } = await supabase.auth.updateUser({ password });
    if (err) { setError(err.message); setLoading(false); return; }
    setSuccess(true);
    setLoading(false);
  };

  return (
    <>
      <style>{styles}</style>
      <div className="reset-page">
        <div className="reset-logo">Pitcher<em>ly</em></div>
        <div className="auth-card" style={{ maxWidth: 400, width: "100%" }}>
          {success ? (
            <div style={{ textAlign: "center" }}>
              <div className="auth-check-icon">✓</div>
              <div className="auth-card-title">Password updated</div>
              <div className="auth-card-sub">Your password has been successfully reset.</div>
              <button className="auth-btn" onClick={() => { window.location.href = "/"; }}>
                Back to login
              </button>
            </div>
          ) : (
            <>
              <div className="auth-card-title">Set new password</div>
              <div className="auth-card-sub">Enter your new password below.</div>
              {error && <div className="auth-error">{error}</div>}
              <form onSubmit={handleReset}>
                <div className="auth-field">
                  <label>New Password</label>
                  <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Min 6 characters" required minLength={6} />
                </div>
                <div className="auth-field">
                  <label>Confirm Password</label>
                  <input type="password" value={confirmPw} onChange={e => setConfirmPw(e.target.value)} placeholder="Confirm password" required minLength={6} />
                </div>
                <button className="auth-btn" type="submit" disabled={loading}>
                  {loading ? "Updating..." : "Update Password"}
                </button>
              </form>
            </>
          )}
        </div>
      </div>
    </>
  );
}
